/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as RecoveryRouteImport } from './routes/recovery'
import { Route as AuthenticatedActivityRouteImport } from './routes/_authenticated/activity'
import { Route as AuthenticatedCategoriesRouteImport } from './routes/_authenticated/categories'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedQuestionsRouteImport } from './routes/_authenticated/questions'
import { Route as AuthenticatedRecoveryRequestsRouteImport } from './routes/_authenticated/recovery-requests'
import { Route as STokenRouteImport } from './routes/s/$token'
import { Route as AuthenticatedExamsIndexRouteImport } from './routes/_authenticated/exams/index'
import { Route as AuthenticatedExamsNewRouteImport } from './routes/_authenticated/exams/new'
import { Route as AuthenticatedResultsIndexRouteImport } from './routes/_authenticated/results/index'
import { Route as AuthenticatedResultsAttemptIdRouteImport } from './routes/_authenticated/results/$attemptId'
import { Route as AuthenticatedSessionsIndexRouteImport } from './routes/_authenticated/sessions/index'
import { Route as AuthenticatedSessionsSessionIdRouteImport } from './routes/_authenticated/sessions/$sessionId'
import { Route as AuthenticatedExamsExamIdEditRouteImport } from './routes/_authenticated/exams/$examId.edit'
import { Route as AuthenticatedResultsSessionSessionIdRouteImport } from './routes/_authenticated/results/session/$sessionId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoveryRoute = RecoveryRouteImport.update({
  id: '/recovery',
  path: '/recovery',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedActivityRoute = AuthenticatedActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCategoriesRoute = AuthenticatedCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedQuestionsRoute = AuthenticatedQuestionsRouteImport.update({
  id: '/questions',
  path: '/questions',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedRecoveryRequestsRoute =
  AuthenticatedRecoveryRequestsRouteImport.update({
    id: '/recovery-requests',
    path: '/recovery-requests',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedExamsIndexRoute = AuthenticatedExamsIndexRouteImport.update({
  id: '/exams/',
  path: '/exams/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedExamsNewRoute = AuthenticatedExamsNewRouteImport.update({
  id: '/exams/new',
  path: '/exams/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedResultsIndexRoute =
  AuthenticatedResultsIndexRouteImport.update({
    id: '/results/',
    path: '/results/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedResultsAttemptIdRoute =
  AuthenticatedResultsAttemptIdRouteImport.update({
    id: '/results/$attemptId',
    path: '/results/$attemptId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSessionsIndexRoute =
  AuthenticatedSessionsIndexRouteImport.update({
    id: '/sessions/',
    path: '/sessions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSessionsSessionIdRoute =
  AuthenticatedSessionsSessionIdRouteImport.update({
    id: '/sessions/$sessionId',
    path: '/sessions/$sessionId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExamsExamIdEditRoute =
  AuthenticatedExamsExamIdEditRouteImport.update({
    id: '/exams/$examId/edit',
    path: '/exams/$examId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedResultsSessionSessionIdRoute =
  AuthenticatedResultsSessionSessionIdRouteImport.update({
    id: '/results/session/$sessionId',
    path: '/results/session/$sessionId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/change-password': typeof ChangePasswordRoute
  '/recovery': typeof RecoveryRoute
  '/activity': typeof AuthenticatedActivityRoute
  '/categories': typeof AuthenticatedCategoriesRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/questions': typeof AuthenticatedQuestionsRoute
  '/recovery-requests': typeof AuthenticatedRecoveryRequestsRoute
  '/s/$token': typeof STokenRoute
  '/exams/new': typeof AuthenticatedExamsNewRoute
  '/results/$attemptId': typeof AuthenticatedResultsAttemptIdRoute
  '/sessions/$sessionId': typeof AuthenticatedSessionsSessionIdRoute
  '/exams/': typeof AuthenticatedExamsIndexRoute
  '/results/': typeof AuthenticatedResultsIndexRoute
  '/sessions/': typeof AuthenticatedSessionsIndexRoute
  '/exams/$examId/edit': typeof AuthenticatedExamsExamIdEditRoute
  '/results/session/$sessionId': typeof AuthenticatedResultsSessionSessionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/change-password': typeof ChangePasswordRoute
  '/recovery': typeof RecoveryRoute
  '/activity': typeof AuthenticatedActivityRoute
  '/categories': typeof AuthenticatedCategoriesRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/questions': typeof AuthenticatedQuestionsRoute
  '/recovery-requests': typeof AuthenticatedRecoveryRequestsRoute
  '/s/$token': typeof STokenRoute
  '/exams/new': typeof AuthenticatedExamsNewRoute
  '/results/$attemptId': typeof AuthenticatedResultsAttemptIdRoute
  '/sessions/$sessionId': typeof AuthenticatedSessionsSessionIdRoute
  '/exams': typeof AuthenticatedExamsIndexRoute
  '/results': typeof AuthenticatedResultsIndexRoute
  '/sessions': typeof AuthenticatedSessionsIndexRoute
  '/exams/$examId/edit': typeof AuthenticatedExamsExamIdEditRoute
  '/results/session/$sessionId': typeof AuthenticatedResultsSessionSessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/change-password': typeof ChangePasswordRoute
  '/recovery': typeof RecoveryRoute
  '/_authenticated/activity': typeof AuthenticatedActivityRoute
  '/_authenticated/categories': typeof AuthenticatedCategoriesRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/questions': typeof AuthenticatedQuestionsRoute
  '/_authenticated/recovery-requests': typeof AuthenticatedRecoveryRequestsRoute
  '/s/$token': typeof STokenRoute
  '/_authenticated/exams/new': typeof AuthenticatedExamsNewRoute
  '/_authenticated/results/$attemptId': typeof AuthenticatedResultsAttemptIdRoute
  '/_authenticated/sessions/$sessionId': typeof AuthenticatedSessionsSessionIdRoute
  '/_authenticated/exams/': typeof AuthenticatedExamsIndexRoute
  '/_authenticated/results/': typeof AuthenticatedResultsIndexRoute
  '/_authenticated/sessions/': typeof AuthenticatedSessionsIndexRoute
  '/_authenticated/exams/$examId/edit': typeof AuthenticatedExamsExamIdEditRoute
  '/_authenticated/results/session/$sessionId': typeof AuthenticatedResultsSessionSessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/change-password'
    | '/recovery'
    | '/activity'
    | '/categories'
    | '/dashboard'
    | '/questions'
    | '/recovery-requests'
    | '/s/$token'
    | '/exams/new'
    | '/results/$attemptId'
    | '/sessions/$sessionId'
    | '/exams/'
    | '/results/'
    | '/sessions/'
    | '/exams/$examId/edit'
    | '/results/session/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/change-password'
    | '/recovery'
    | '/activity'
    | '/categories'
    | '/dashboard'
    | '/questions'
    | '/recovery-requests'
    | '/s/$token'
    | '/exams/new'
    | '/results/$attemptId'
    | '/sessions/$sessionId'
    | '/exams'
    | '/results'
    | '/sessions'
    | '/exams/$examId/edit'
    | '/results/session/$sessionId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth'
    | '/change-password'
    | '/recovery'
    | '/_authenticated/activity'
    | '/_authenticated/categories'
    | '/_authenticated/dashboard'
    | '/_authenticated/questions'
    | '/_authenticated/recovery-requests'
    | '/s/$token'
    | '/_authenticated/exams/new'
    | '/_authenticated/results/$attemptId'
    | '/_authenticated/sessions/$sessionId'
    | '/_authenticated/exams/'
    | '/_authenticated/results/'
    | '/_authenticated/sessions/'
    | '/_authenticated/exams/$examId/edit'
    | '/_authenticated/results/session/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthRoute: typeof AuthRoute
  ChangePasswordRoute: typeof ChangePasswordRoute
  RecoveryRoute: typeof RecoveryRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recovery': {
      id: '/recovery'
      path: '/recovery'
      fullPath: '/recovery'
      preLoaderRoute: typeof RecoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/activity': {
      id: '/_authenticated/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedActivityRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories': {
      id: '/_authenticated/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof AuthenticatedCategoriesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/questions': {
      id: '/_authenticated/questions'
      path: '/questions'
      fullPath: '/questions'
      preLoaderRoute: typeof AuthenticatedQuestionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/recovery-requests': {
      id: '/_authenticated/recovery-requests'
      path: '/recovery-requests'
      fullPath: '/recovery-requests'
      preLoaderRoute: typeof AuthenticatedRecoveryRequestsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/exams/': {
      id: '/_authenticated/exams/'
      path: '/exams'
      fullPath: '/exams/'
      preLoaderRoute: typeof AuthenticatedExamsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/exams/new': {
      id: '/_authenticated/exams/new'
      path: '/exams/new'
      fullPath: '/exams/new'
      preLoaderRoute: typeof AuthenticatedExamsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/results/': {
      id: '/_authenticated/results/'
      path: '/results'
      fullPath: '/results/'
      preLoaderRoute: typeof AuthenticatedResultsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/results/$attemptId': {
      id: '/_authenticated/results/$attemptId'
      path: '/results/$attemptId'
      fullPath: '/results/$attemptId'
      preLoaderRoute: typeof AuthenticatedResultsAttemptIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sessions/': {
      id: '/_authenticated/sessions/'
      path: '/sessions'
      fullPath: '/sessions/'
      preLoaderRoute: typeof AuthenticatedSessionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sessions/$sessionId': {
      id: '/_authenticated/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/sessions/$sessionId'
      preLoaderRoute: typeof AuthenticatedSessionsSessionIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/exams/$examId/edit': {
      id: '/_authenticated/exams/$examId/edit'
      path: '/exams/$examId/edit'
      fullPath: '/exams/$examId/edit'
      preLoaderRoute: typeof AuthenticatedExamsExamIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/results/session/$sessionId': {
      id: '/_authenticated/results/session/$sessionId'
      path: '/results/session/$sessionId'
      fullPath: '/results/session/$sessionId'
      preLoaderRoute: typeof AuthenticatedResultsSessionSessionIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedActivityRoute: typeof AuthenticatedActivityRoute
  AuthenticatedCategoriesRoute: typeof AuthenticatedCategoriesRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedQuestionsRoute: typeof AuthenticatedQuestionsRoute
  AuthenticatedRecoveryRequestsRoute: typeof AuthenticatedRecoveryRequestsRoute
  AuthenticatedExamsNewRoute: typeof AuthenticatedExamsNewRoute
  AuthenticatedResultsAttemptIdRoute: typeof AuthenticatedResultsAttemptIdRoute
  AuthenticatedSessionsSessionIdRoute: typeof AuthenticatedSessionsSessionIdRoute
  AuthenticatedExamsIndexRoute: typeof AuthenticatedExamsIndexRoute
  AuthenticatedResultsIndexRoute: typeof AuthenticatedResultsIndexRoute
  AuthenticatedSessionsIndexRoute: typeof AuthenticatedSessionsIndexRoute
  AuthenticatedExamsExamIdEditRoute: typeof AuthenticatedExamsExamIdEditRoute
  AuthenticatedResultsSessionSessionIdRoute: typeof AuthenticatedResultsSessionSessionIdRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedActivityRoute: AuthenticatedActivityRoute,
  AuthenticatedCategoriesRoute: AuthenticatedCategoriesRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedQuestionsRoute: AuthenticatedQuestionsRoute,
  AuthenticatedRecoveryRequestsRoute: AuthenticatedRecoveryRequestsRoute,
  AuthenticatedExamsNewRoute: AuthenticatedExamsNewRoute,
  AuthenticatedResultsAttemptIdRoute: AuthenticatedResultsAttemptIdRoute,
  AuthenticatedSessionsSessionIdRoute: AuthenticatedSessionsSessionIdRoute,
  AuthenticatedExamsIndexRoute: AuthenticatedExamsIndexRoute,
  AuthenticatedResultsIndexRoute: AuthenticatedResultsIndexRoute,
  AuthenticatedSessionsIndexRoute: AuthenticatedSessionsIndexRoute,
  AuthenticatedExamsExamIdEditRoute: AuthenticatedExamsExamIdEditRoute,
  AuthenticatedResultsSessionSessionIdRoute:
    AuthenticatedResultsSessionSessionIdRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthRoute: AuthRoute,
  ChangePasswordRoute: ChangePasswordRoute,
  RecoveryRoute: RecoveryRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
